import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { styled } from "@mui/material";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import InputTextField from "../../../../../components/input/inputTextField";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../../../components/button/ButtonCustoms";
import { alertSuccess } from "../../../../../components/alert/swal";
import { StudentApi } from "../../../../../api/student/student.api";
import {
  setLoading,
  unsetLoading,
} from "../../../../../store/loading/loading.slice";
import ModalCustom from "../../../../../components/modal/ModalCustom";

const IconEye = styled(VisibilityOffOutlinedIcon)({
  transform: "rotate(-180deg)",
  cursor: "pointer",
  "&:hover": {
    opacity: 1,
  },
});

type Props = {
  isOpenModal: boolean;
  setIsOpenModal: (isOpen: boolean) => void; // Accepts a boolean argument
};

const ModalChangePassword: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { isOpenModal, setIsOpenModal } = props;
  const dispatch = useDispatch();
  const [togglePassword, setTogglePassword] = useState<boolean>(false);
  const [confirmTogglePassword, setConfirmTogglePassword] =
    useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const [formChangePassword, setFormChangePassword] = useState<{
    password: string;
    confirmPassword: string;
  }>({
    password: "",
    confirmPassword: "",
  });

  const handleChange = (name: string, value: string) => {
    setErrorMessage("");
    setFormChangePassword((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (id_student: number) => {
    if (!formChangePassword.password) {
      return setErrorMessage(t("ระบุรหัสผ่านใหม่ที่ต้องการ"));
    } else if (!formChangePassword.confirmPassword) {
      return setErrorMessage(t("ระบุรหัสผ่านใหม่ที่ต้องการ"));
    } else if (
      formChangePassword.password !== formChangePassword.confirmPassword
    ) {
      return setErrorMessage(t("รหัสผ่านไม่ตรงกัน"));
    }

    const body: {
      password: string;
    } = {
      password: formChangePassword.password,
    };

    dispatch(setLoading());

    await StudentApi.resetPassword(id_student, body)
      .then((res) => {
        if (res.status < 300) {
          dispatch(unsetLoading());
          alertSuccess(
            t("แก้ไขรหัสผ่าน"),
            t("แก้ไขรหัสผ่าน เรียบร้อยแล้ว"),
            undefined,
            () => {
              setIsOpenModal(false);
              setFormChangePassword({
                password: "",
                confirmPassword: "",
              });
            }
          );
        }
      })
      .catch((error) => console.log(error));
  };
  return (
    <ModalCustom
      title={t("แก้ไขรหัสผ่าน")}
      subTitle={t("กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน")}
      open={isOpenModal}
      onClose={() => {
        setIsOpenModal(false);
      }}
      component={
        <section className="grid grid-cols-12 gap-y-6">
          <article className="col-span-12">
            <InputTextField
              value={formChangePassword.password}
              helperText={errorMessage}
              type={togglePassword ? "text" : "password"}
              heading={t("รหัสผ่านใหม่")}
              placeholder={t("ระบุรหัสผ่านใหม่")}
              onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleChange("password", e.target.value)
              }
              endAdornment={
                <IconEye
                  onClick={() => setTogglePassword(!togglePassword)}
                  sx={{ opacity: !togglePassword ? 0.3 : 1 }}
                />
              }
            />
          </article>
          <article className="col-span-12">
            <InputTextField
              value={formChangePassword.confirmPassword}
              helperText={errorMessage}
              type={confirmTogglePassword ? "text" : "password"}
              placeholder={t("ยืนยันรหัสผ่านใหม่อีกครั้ง")}
              heading={t("ยืนยันรหัสผ่านใหม่อีกครั้ง")}
              onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleChange("confirmPassword", e.target.value)
              }
              endAdornment={
                <IconEye
                  onClick={() =>
                    setConfirmTogglePassword(!confirmTogglePassword)
                  }
                  sx={{ opacity: !confirmTogglePassword ? 0.3 : 1 }}
                />
              }
            />
          </article>
          <article className="col-span-12 flex items-center justify-center gap-4 my-4">
            <ButtonOutlined
              onClick={() => {
                setIsOpenModal(false);
                setErrorMessage("");
                setFormChangePassword({
                  password: "",
                  confirmPassword: "",
                });
              }}
              mode="del"
              buttonName={t("ยกเลิก")}
            />
            <ButtonPrimary
              disabled={
                !formChangePassword.password ||
                !formChangePassword.confirmPassword
              }
              onClick={() => id && handleSubmit(+id)}
              mode="success"
              buttonName={t("ยืนยัน")}
            />
          </article>
        </section>
      }
    />
  );
};

export default ModalChangePassword;
